module.exports = __webpack_public_path__ + "img/qinban_logo.0af322c9.svg";